export const loginUrls = {
    loginWithPassword: "passenger/login/",
    requestOtp: "passenger/login/mobile",
    loginWithOtp: "passenger/login/otp-verification"

};
export default loginUrls;
